import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "item-name-container" }
const _hoisted_3 = { class: "bg-dark" }
const _hoisted_4 = { class: "item-image-container" }
const _hoisted_5 = { class: "image-wrapper" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "bg-dark td-item-stats" }
const _hoisted_8 = { class: "item-stats-container" }
const _hoisted_9 = {
  style: {"width":"16px","height":"16px"},
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, [
        _createElementVNode("div", {
          class: "item-type-container bg-dark",
          style: _normalizeStyle(`color: ${_ctx.getItemPrefixData(Object.keys(_ctx.item.bonusStats).length).color}; `)
        }, _toDisplayString(_ctx.item.prefix), 5)
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.item.name), 1)
      ])
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "item-image",
              src: require(`../../../assets/img/gear/${_ctx.item.slot}/${_ctx.item.image}.gif`),
              alt: ""
            }, null, 8, _hoisted_6)
          ]),
          _createVNode(_component_GenericButton, {
            text: "EQUIP",
            "font-size": "14px",
            title: "Click to equip this item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.equipItem(_ctx.item.slot, _ctx.item.image, _ctx.item)))
          })
        ])
      ]),
      _createElementVNode("td", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.item.bonusStats), (stat) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "used-stat",
              key: stat[0]
            }, _toDisplayString(_ctx.statNamesMap[stat[0]] + (['CritChance', 'CritPower'].includes(stat[0]) && ['head', 'body'].includes(_ctx.item.slot) ? ' -' : ' +') + stat[1]), 1))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "delete-icon-container",
          title: "Delete this item from inventory",
          onClick: _cache[1] || (_cache[1] = () => _ctx.deleteItem(_ctx.item, _ctx.itemIndex))
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("path", {
              fill: "currentColor",
              d: "M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z"
            }, null, -1)
          ]))]))
        ])
      ])
    ])
  ]))
}